import React from "react";
import ReactDOM from "react-dom";
import { BiError } from "react-icons/bi";
import { BsCheckCircleFill } from "react-icons/bs";
import * as Elements from "./elements.js";

class ModalComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			modalData: {
				isOpen: false,
				isError: true,
				title: "Placeholder Title",
				message:
					"Placeholder Message. Please Ignore This Message. An Error Has Occurred",
				confirmFunction: () => {
					window.location.reload();
				},
			},
		};

		this.containerAnimation = {
			open: { opacity: 1, visibility: "visible" },
			closed: { opacity: 0, visibility: "hidden" },
		};

		this.containerInnerAnimation = {
			open: { opacity: 1, scale: 1 },
			closed: { opacity: 0, scale: 0.5 },
		};
	}

	setModalDataMethod(data) {
		this.setState({ modalData: data });
	}

	handleConfirm() {
		if (this.state.modalData.confirmFunction === undefined) {
			this.setState({
				modalData: { ...this.state.modalData, isOpen: false },
			});
		} else {
			this.state.modalData.confirmFunction();
		}
	}

	render() {
		const modalData = this.state.modalData;
		const containerAnimation = this.containerAnimation;
		const containerInnerAnimation = this.containerInnerAnimation;

		return ReactDOM.createPortal(
			<Elements.Container
				animate={modalData.isOpen ? "open" : "closed"}
				variants={containerAnimation}
			>
				<Elements.ContainerInner
					animate={modalData.isOpen ? "open" : "closed"}
					variants={containerInnerAnimation}
				>
					<Elements.Icon>
						{modalData.isError ? (
							<BiError />
						) : (
							<BsCheckCircleFill />
						)}
					</Elements.Icon>
					<Elements.Title>{modalData.title}</Elements.Title>
					<Elements.Message>{modalData.message}</Elements.Message>
					<Elements.Button onClick={() => this.handleConfirm()}>
						Close
					</Elements.Button>
				</Elements.ContainerInner>
			</Elements.Container>,
			document.body
		);
	}
}

// function ModalComponent() {
// 	const [modalData, setModalData] = useState({
// 		isOpen: false,
// 		title: "",
// 		text: "",
// 		confirmFunction: () => {
// 			return null;
// 		},
// 	});

// 	const containerAnimation = {
// 		open: { opacity: 1, visibility: "visible" },
// 		closed: { opacity: 0, visibility: "hidden" },
// 	};

// 	const containerInnerAnimation = {
// 		open: { opacity: 1, scale: 1 },
// 		closed: { opacity: 0, scale: 0.5 },
// 	};

// 	return ReactDOM.createPortal(
// 		<Elements.Container
// 			animate={modalData.isOpen ? "open" : "closed"}
// 			variants={containerAnimation}
// 		>
// 			<Elements.ContainerInner
// 				animate={modalData.isOpen ? "open" : "closed"}
// 				variants={containerInnerAnimation}
// 			>
// 				<h1>{modalData.title}</h1>
// 				<button
// 					onClick={() =>
// 						setModalData({
// 							isOpen: false,
// 							title: "",
// 							text: "",
// 							confirmFunction: () => {
// 								return null;
// 							},
// 						})
// 					}
// 				>
// 					Close Modal
// 				</button>
// 			</Elements.ContainerInner>
// 		</Elements.Container>,
// 		document.body
// 	);
// }

export default ModalComponent;
